/**
 * Generate initials from an organization name
 * Takes the first letter of each word, up to 3 characters
 * 
 * @param {string} orgName - The organization name
 * @returns {string} - Up to 3 uppercase initials
 * 
 * Examples:
 * - "Liquid QR" → "LQ"
 * - "Liquid QR Code" → "LQC"
 * - "Tesla" → "T"
 * - "" → "?"
 */
export const getOrgInitials = (orgName) => {
    if (!orgName || typeof orgName !== 'string') {
        return '';
    }

    const trimmed = orgName.trim();
    if (trimmed === '') {
        return '';
    }
    
    if (trimmed === 'Unnamed Organization' || trimmed === 'Personal Account' ) {
        return '';
    }

    // Split by spaces and get first letter of each word
    const words = trimmed.split(/\s+/);
    const initials = words
        .map(word => word.charAt(0).toUpperCase())
        .filter(char => char.match(/[A-Z0-9]/)) // Only keep alphanumeric
        .slice(0, 2) // Max 3 characters
        .join('');

    return initials || '?';
};
